import http from '../fetch';
const { get: httpGet, post: httpPost } = http;

// 获取资讯全部分类
export const getCateAll = () => httpGet('/article/category/all');
// 删除当前资讯分类
export const deleteCategpry = data => httpGet(`/admin/article/category/delete`, data);
// 更新当前资讯分类名称
export const updateCategory = data => httpPost('/admin/article/category/update', data);
//添加资讯分类
export const addCategory = data => httpPost('/admin/article/category/add', data);



// WEBPACK FOOTER //
// ./src/api/category/index.js